import React from 'react';
import $ from '~/helpers/$';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import './accordion-group.scss';
function useChevronDirection(forwardOnChange, preExpanded) {
    const [openTabs, updateOpenTabs] = React.useState([...preExpanded]);
    const chevronDirection = React.useCallback((uuid) => (openTabs.includes(uuid) ? 'up' : 'down'), [openTabs]);
    const onChange = React.useCallback((newOpenTabs) => {
        if (forwardOnChange) {
            forwardOnChange(newOpenTabs);
        }
        updateOpenTabs(newOpenTabs);
    }, [forwardOnChange, updateOpenTabs]);
    return [chevronDirection, onChange];
}
function TitleBar({ title, titleTag, chevronDirection, analytics }) {
    const icon = {
        down: faChevronDown,
        up: faChevronUp
    }[chevronDirection];
    const isOpen = chevronDirection === 'up';
    return (React.createElement(AccordionItemHeading, { "aria-level": "2" },
        React.createElement(AccordionItemButton, { className: "accordion-button", "data-analytics-link": analytics && !isOpen ? '' : undefined },
            React.createElement("div", { className: "label" },
                title,
                titleTag && React.createElement("span", { className: "title-tag" }, titleTag)),
            React.createElement("div", { className: "chevron" },
                React.createElement(FontAwesomeIcon, { icon: icon })))));
}
function toUuid(name) {
    return name.replace(/\W+/g, '_');
}
function Item({ title, titleTag, checkChevronDirection, contentComponent, analytics }) {
    const uuid = toUuid(title);
    const chevronDirection = checkChevronDirection(uuid);
    return (React.createElement(AccordionItem, { uuid: uuid, className: "accordion-item" },
        React.createElement(TitleBar, { title,
            titleTag,
            chevronDirection,
            analytics }),
        React.createElement(AccordionItemPanel, { className: "content-pane" }, contentComponent)));
}
export default function AccordionGroup({ items, accordionProps = { allowZeroExpanded: true }, noScroll = false, forwardOnChange = false, preExpanded = [], 'data-analytics-nav': analyticsNav }) {
    const root = React.useRef(null);
    const preExpandedUuids = preExpanded.map(toUuid);
    const [chevronDirection, onChange] = useChevronDirection(forwardOnChange, preExpandedUuids);
    const scrollAndChangeChevronPlus = React.useCallback((newOpenTabs) => {
        if (!noScroll) {
            window.setTimeout(() => {
                var _a;
                const openItem = (_a = root.current) === null || _a === void 0 ? void 0 : _a.querySelector('[aria-expanded="true"]');
                if (openItem) {
                    $.scrollTo(openItem);
                }
            }, 20);
        }
        onChange(newOpenTabs);
    }, [onChange, noScroll]);
    return (React.createElement("div", { ref: root },
        React.createElement(Accordion, Object.assign({}, accordionProps, { onChange: scrollAndChangeChevronPlus, className: "accordion-group", preExpanded: preExpandedUuids, "data-analytics-nav": analyticsNav }), items.map((item) => item.inline || (React.createElement(Item, Object.assign({ analytics: !!analyticsNav, key: item.title }, item, { checkChevronDirection: chevronDirection })))))));
}
